import React, { useState } from 'react';
import Menu from './Menu';
import Categories from './Categories';
import items from './data';

const allCategories = ["all", ...new Set(items.map(item=> item.category))];

function App() {
  const [menuItems, setMenuItems] = useState(items);
  const [categories, _] = useState(allCategories);

  const filterItems = (category)=> {
    if(category === "all") {
      setMenuItems(items);
    }
    else {
      const newItems = items.filter(item=> item.category === category);
      setMenuItems(newItems);
    }
  }

  return(
    <main>
      <div className="menu section">
        <div className="title">
          <h2>Our menu</h2>
          <div className="underline"></div>
        </div>
        <Categories categories={categories} filterItems={filterItems}/>
        <Menu items={menuItems}/>
      </div>
    </main>
  )
}

export default App;
